import React, { useState, useRef } from "react";
import ReCAPTCHA from 'react-google-recaptcha';
import "../styles/join.css";

const SUBMIT_EMAIL    = "yokaisoftware66@gmail.com";
const RECAPTCHA_KEY   = "6LdwstIpAAAAAL1_lBneLQEQRHpyUpxdO5ZXJ0R9";

export default function JoinModal({ isOpen, onClose }) {
  const [step, setStep]                 = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError]               = useState("");
  const [startTime]                     = useState(Date.now());
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const formRef      = useRef(null);
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName:  '',
    email:     '',
    location:  '',
    plan:      'annual',
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  function handleClose() {
    setStep(1);
    setError("");
    setRecaptchaToken('');
    recaptchaRef.current?.reset();
    setFormData({ firstName: '', lastName: '', email: '', location: '', plan: 'annual' });
    onClose();
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (Date.now() - startTime < 3000) {
      alert('Submission too fast.');
      return;
    }

    if (!recaptchaToken) {
      alert('Please complete the reCAPTCHA.');
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      const submission = new FormData();
      submission.append('firstName', formData.firstName);
      submission.append('lastName',  formData.lastName);
      submission.append('email',     formData.email);
      submission.append('location',  formData.location);
      submission.append('plan',      formData.plan);
      submission.append('_subject',  `Axis Membership Interest — ${formData.firstName} ${formData.lastName}`);
      submission.append('_template', 'table');
      submission.append('_captcha',  'false');
      submission.append('_replyto',  formData.email);
      submission.append('_honey',    '');

      const response = await fetch(
        `https://formsubmit.co/ajax/${SUBMIT_EMAIL}`,
        { method: 'POST', headers: { Accept: 'application/json' }, body: submission }
      );
      const result = await response.json();

      if (result.success === 'true' || response.ok) {
        setStep(3);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  if (!isOpen) return null;

  return (
    <div className="jm__overlay" onClick={handleClose}>
      <div className="jm__box" onClick={e => e.stopPropagation()}>

        <button className="jm__close" onClick={handleClose} aria-label="Close">✕</button>

        {step < 3 && (
          <div className="jm__steps">
            {[1, 2].map(n => (
              <div
                key={n}
                className={`jm__step-dot ${step >= n ? 'jm__step-dot--active' : ''}`}
              />
            ))}
          </div>
        )}

        {/* ── STEP 1 ── */}
        {step === 1 && (
          <div className="jm__content">
            <span className="jm__eyebrow">The Axis</span>
            <h2 className="jm__title">Join the Organization</h2>
            <p className="jm__body">
              Membership in the Axis is not a subscription to a service. It is
              an acceptance of a set of obligations — to the Sacred Three, to the
              community, and to yourself.
            </p>
            <div className="jm__summary">
              <div className="jm__summary-row">
                <span className="jm__summary-label">What you accept</span>
                <span className="jm__summary-value">
                  The Sacred Three as non-negotiable principles governing your decisions and actions.
                </span>
              </div>
              <div className="jm__summary-row">
                <span className="jm__summary-label">What you commit to</span>
                <span className="jm__summary-value">
                  Daily practice, community participation, and regular contribution to Axis charitable and community actions.
                </span>
              </div>
              <div className="jm__summary-row">
                <span className="jm__summary-label">What you gain</span>
                <span className="jm__summary-value">
                  Access to the platform, the Codex, the community, connection to local chapters, and the standing of an Axis member.
                </span>
              </div>
              <div className="jm__summary-row">
                <span className="jm__summary-label">Dues</span>
                <span className="jm__summary-value">
                  Nominal — sufficient to sustain the organization and its mission. Details at next step.
                </span>
              </div>
            </div>
            <div className="jm__actions">
              <button className="btn btn--primary" onClick={() => setStep(2)}>
                I'm Ready — Continue
              </button>
              <button className="btn btn--ghost" onClick={handleClose}>
                Not Yet
              </button>
            </div>
          </div>
        )}

        {/* ── STEP 2 ── */}
        {step === 2 && (
          <div className="jm__content">
            <span className="jm__eyebrow">Membership</span>
            <h2 className="jm__title">Your Details</h2>
            <p className="jm__body">
              Complete the form below. We will be in touch to confirm your
              membership and process dues once the system is live.
            </p>

            <div className="jm__plan-selector">
              <button
                className={`jm__plan-btn ${formData.plan === 'monthly' ? 'jm__plan-btn--active' : ''}`}
                onClick={() => setFormData(prev => ({ ...prev, plan: 'monthly' }))}
                type="button"
              >
                <span className="jm__plan-label">Monthly</span>
                <span className="jm__plan-price">TBD / mo</span>
              </button>
              <button
                className={`jm__plan-btn ${formData.plan === 'annual' ? 'jm__plan-btn--active' : ''}`}
                onClick={() => setFormData(prev => ({ ...prev, plan: 'annual' }))}
                type="button"
              >
                <span className="jm__plan-label">Annual</span>
                <span className="jm__plan-price">TBD / yr</span>
                <span className="jm__plan-badge">Best Value</span>
              </button>
            </div>

            <form ref={formRef} onSubmit={handleSubmit} className="jm__form" noValidate>
              <div className="jm__field-row">
                <div className="jm__field">
                  <label className="jm__label" htmlFor="jm-first">First Name</label>
                  <input
                    id="jm-first"
                    className="jm__input"
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    autoComplete="given-name"
                    required
                  />
                </div>
                <div className="jm__field">
                  <label className="jm__label" htmlFor="jm-last">Last Name</label>
                  <input
                    id="jm-last"
                    className="jm__input"
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    autoComplete="family-name"
                    required
                  />
                </div>
              </div>
              <div className="jm__field">
                <label className="jm__label" htmlFor="jm-email">Email</label>
                <input
                  id="jm-email"
                  className="jm__input"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                />
              </div>
              <div className="jm__field">
                <label className="jm__label" htmlFor="jm-location">
                  City / State <span className="jm__label-note">(for chapter matching)</span>
                </label>
                <input
                  id="jm-location"
                  className="jm__input"
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="e.g. Sarasota, FL"
                />
              </div>

              <input type="text" name="_honey" style={{ display: 'none' }} />

              {error && <p className="jm__error">{error}</p>}

              <div className="jm__captcha">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_KEY}
                  onChange={token => setRecaptchaToken(token || '')}
                  theme="dark"
                />
              </div>

              <div className="jm__actions">
                <button
                  className="btn btn--primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting…" : "Submit Interest"}
                </button>
                <button
                  className="btn btn--ghost"
                  type="button"
                  onClick={() => setStep(1)}
                >
                  Back
                </button>
              </div>
              <p className="jm__fine-print">
                No payment is taken at this stage. You will be contacted when
                the membership system goes live.
              </p>
              <p className="jm__fine-print">
                The Axis will never sell your information or share it with third
                parties except as required to process your membership or as
                required by law.
              </p>
            </form>
          </div>
        )}

        {/* ── STEP 3 ── */}
        {step === 3 && (
          <div className="jm__content jm__content--success">
            <div className="jm__success-icon" aria-hidden="true">
              <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/>
                <path d="M15 24l7 7 11-12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="jm__eyebrow">Received</span>
            <h2 className="jm__title">Welcome to the Axis</h2>
            <p className="jm__body">
              Your interest has been recorded. You will receive a confirmation
              email and further details when the membership system is live.
              The work begins now — not when the paperwork is finalized.
            </p>
            <p className="jm__mantra">
              Reverence is the why. Power is the can. Duty is the must.
            </p>
            <div className="jm__actions">
              <button className="btn btn--primary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}